// Casquette active d'un LIVREUR À PROFIL MIXTE : « livreur » (par défaut) ou
// « vendeur ». Ce n'est PAS un rôle : le rôle en base et dans le jeton reste
// « livreur ». La casquette ne fait que piloter la NAVIGATION (quels écrans il
// voit) ; ses DROITS, eux, viennent du serveur et ne changent pas quand il
// bascule — c'est ce qui empêche toute escalade de privilèges.
//
// RETOUR AUTOMATIQUE EN LIVREUR CHAQUE JOUR (arbitrage proprio) : la casquette
// est mémorisée avec sa date ; au premier chargement d'un nouveau jour, elle
// repart sur « livreur » pour qu'il ne rate pas ses livraisons du matin.

const CLE = 'ndoe:casquette';

const jourCourant = () => {
  // Jour en fuseau AFRICA/KINSHASA (et non celui du téléphone) : un appareil mal
  // réglé ferait sinon repartir la casquette au mauvais moment.
  try {
    return new Intl.DateTimeFormat('en-CA', { timeZone: 'Africa/Kinshasa' }).format(new Date());
  } catch (e) {
    const d = new Date();
    const p2 = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`;
  }
};

export const lireCasquette = () => {
  try {
    const brut = window.localStorage.getItem(CLE);
    if (!brut) return 'livreur';
    const { mode, jour } = JSON.parse(brut);
    if (jour !== jourCourant()) return 'livreur'; // nouveau jour → retour livreur
    return mode === 'vendeur' ? 'vendeur' : 'livreur';
  } catch (e) { return 'livreur'; }
};

export const ecrireCasquette = (mode) => {
  try {
    window.localStorage.setItem(CLE, JSON.stringify({ mode, jour: jourCourant() }));
  } catch (e) { /* stockage indisponible : la casquette reste celle de la session */ }
  // Le routeur est construit au montage : on recharge pour rebrancher la
  // navigation d'un bloc à l'autre (même mécanisme que le changement de rôle).
  window.location.assign('/');
};

export default { lireCasquette, ecrireCasquette };
